import { AutogenModelWebMenuGroup, AutogenRowWebMenuGroup } from "./autogen/AutogenModelWebMenuGroup";

export class ModelWebMenuGroup extends AutogenModelWebMenuGroup<RowWebMenuGroup> {
	constructor() {
		super(RowWebMenuGroup);
	}
}

export enum RowWebMenuGroupType {
	ROOT = "R",
	LEAF = "L",
	BRANCH = "B",
	SHARED = "S",
	SHARED_REFERENCE = "SR",
}


export class RowWebMenuGroup extends AutogenRowWebMenuGroup {
}
